import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=3852402d&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=3852402d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852402d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/builds/master/frontend/frontend-universe/components/avatar.vue').default,SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default,Card: require('/builds/master/frontend/frontend-universe/components/card/card.vue').default,EmptyUser: require('/builds/master/frontend/frontend-universe/components/empty-user.vue').default})
